import React from 'react';
import './Automation.css';

interface AutomationProps {
  automation: {
    manager: number;
    devConsole: number;
    cicd: number;
  };
  coins: number;
  onUpgrade: (type: 'manager' | 'devConsole' | 'cicd') => void;
}

const Automation: React.FC<AutomationProps> = ({ automation, coins, onUpgrade }) => {
  const getUpgradeCost = (level: number): number => {
    return Math.floor(20 * Math.pow(1.8, level));
  };

  const canAfford = (level: number): boolean => {
    return coins >= getUpgradeCost(level);
  };

  const isMaxLevel = (level: number): boolean => {
    return level >= 10;
  };

  const getAutomationEffect = (type: 'manager' | 'devConsole' | 'cicd', level: number): string => {
    switch (type) {
      case 'manager':
        return `Auto-push every ${Math.max(1, 11 - level)}s`;
      case 'devConsole':
        return `+${level} coins per ascension`;
      case 'cicd':
        return `+${level} score per ascension`;
      default:
        return '';
    }
  };

  return (
    <div className="automation-container">
      <h3 className="automation-title">⚙️ Automation</h3>
      <div className="automation-items">
        {/* Manager */}
        <div className="automation-item">
          <div className="automation-header">
            <span className="automation-icon">👔</span>
            <div className="automation-info">
              <h4>Manager</h4>
              <p className="automation-description">
                Level {automation.manager}/10 • {getAutomationEffect('manager', automation.manager)}
              </p>
            </div>
          </div>
          <button
            className={`automation-button ${isMaxLevel(automation.manager) ? 'max-level' : canAfford(automation.manager) ? 'affordable' : 'unaffordable'}`}
            onClick={() => onUpgrade('manager')}
            disabled={isMaxLevel(automation.manager) || !canAfford(automation.manager)}
          >
            {isMaxLevel(automation.manager) 
              ? 'MAX' 
              : `${getUpgradeCost(automation.manager)} 🪙`}
          </button>
        </div>

        {/* Dev Console */}
        <div className="automation-item">
          <div className="automation-header">
            <span className="automation-icon">💻</span>
            <div className="automation-info">
              <h4>Dev Console</h4>
              <p className="automation-description">
                Level {automation.devConsole}/10 • {getAutomationEffect('devConsole', automation.devConsole)}
              </p>
            </div>
          </div>
          <button
            className={`automation-button ${isMaxLevel(automation.devConsole) ? 'max-level' : canAfford(automation.devConsole) ? 'affordable' : 'unaffordable'}`}
            onClick={() => onUpgrade('devConsole')}
            disabled={isMaxLevel(automation.devConsole) || !canAfford(automation.devConsole)}
          >
            {isMaxLevel(automation.devConsole) 
              ? 'MAX' 
              : `${getUpgradeCost(automation.devConsole)} 🪙`}
          </button>
        </div>

        {/* CI/CD */}
        <div className="automation-item">
          <div className="automation-header">
            <span className="automation-icon">🔄</span>
            <div className="automation-info">
              <h4>CI/CD</h4>
              <p className="automation-description">
                Level {automation.cicd}/10 • {getAutomationEffect('cicd', automation.cicd)}
              </p>
            </div>
          </div>
          <button
            className={`automation-button ${isMaxLevel(automation.cicd) ? 'max-level' : canAfford(automation.cicd) ? 'affordable' : 'unaffordable'}`}
            onClick={() => onUpgrade('cicd')}
            disabled={isMaxLevel(automation.cicd) || !canAfford(automation.cicd)}
          >
            {isMaxLevel(automation.cicd) 
              ? 'MAX' 
              : `${getUpgradeCost(automation.cicd)} 🪙`}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Automation;

